import { FC } from "react";
import styles from "./HistoricalDataFields.module.scss";

export const GlOnlyNote: FC = () => (
    <div className={styles.glOnlyNote}>
        Only the <strong>general ledger</strong> can be migrated from
        non-QuickBooks systems. Counterparties and classes will need to be
        re-entered.
    </div>
);
